import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import FeedbackForm from "@/components/FeedbackForm";

export default function FeedbackDialog({ open, onClose }) {
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-[#2D2A26]/40 backdrop-blur-sm"
          onClick={onClose}
          data-testid="feedback-dialog-overlay"
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.96, y: 12 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.96, y: 12 }}
            transition={{ duration: 0.25 }}
            onClick={(e) => e.stopPropagation()}
            className="relative w-full max-w-lg rounded-3xl bg-[#FDFBF7] border border-[#E8E3D9] p-7 sm:p-8 shadow-xl"
            data-testid="feedback-dialog"
          >
            <button
              onClick={onClose}
              data-testid="feedback-dialog-close"
              className="absolute top-5 right-5 p-1.5 rounded-full text-[#6E6860] hover:bg-[#F5F2EA] transition-colors"
            >
              <X className="h-5 w-5" />
            </button>
            <p className="text-xs uppercase tracking-[0.2em] text-[#6E6860] mb-2">In active development</p>
            <h2 className="font-serif text-2xl text-[#2D2A26] mb-1.5">Please… we'd love your feedback</h2>
            <p className="text-sm text-[#6E6860] mb-6">
              Common Ground Explorer is a work in progress and your input directly shapes what comes next. Help us improve!
            </p>
            <FeedbackForm onSubmitted={() => setTimeout(onClose, 1800)} />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
